import React, { useState } from "react";

const Slider = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  return (
    <div className="relative w-full overflow-hidden flex items-center justify-center py-5 px-10">
      {/* Previous Button */}
      <button className={`absolute left-0 top-1/2 -translate-y-1/2 text-white shadow-lg w-10 h-10 rounded-full flex items-center justify-center text-sm z-10 border border-brand border-solid
        ${currentSlide === 0 ? "bg-[#D9E7F7] cursor-default" : "bg-gradient-to-r from-[#022B5C] to-[#0363C4] hover:from-[#0363C4] hover:to-[#022B5C] cursor-pointer"}`}
        onClick={prevSlide} disabled={currentSlide === 0}>
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={currentSlide === 0 ? "#3C3C3C" : "#FFFFFF"} width={24} height={24}>
          <path d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"></path>
        </svg>
      </button>

      {/* Slider Wrapper */}
      <div className="w-[95%] mx-auto overflow-hidden relative">
        <div className="flex transition-transform duration-300 ease-in-out" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
          {slides.map((slide, index) => (
            <div key={index} className="w-full flex-shrink-0">
              <div className="text-center bg-white rounded-[20px] p-5 sm:p-3  min-h-[230px] sm:min-h-[280px]">
                    <p className="text-base2 mb-[40px] sm:mb-[20px]">
                      {slide.content}
                    </p>
                    {slide.name && (
                      <>
                        <h3 className="text-xl text-[#333333] font-semibold mb-1">{slide.name} </h3>
                        <p className="text-base text-[#3C3C3C]"> {slide.position}</p>
                      </>
                    )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Next Button */}
      <button className={`absolute right-0 top-1/2 -translate-y-1/2 text-white shadow-lg w-10 h-10 rounded-full flex items-center justify-center text-sm z-10 border border-brand border-solid
        ${currentSlide === slides.length - 1 ? "bg-[#D9E7F7] cursor-default" : "bg-gradient-to-r from-[#022B5C] to-[#0363C4] hover:from-[#0363C4] hover:to-[#022B5C] cursor-pointer"}`}
        onClick={nextSlide}
        disabled={currentSlide === slides.length - 1}>
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={currentSlide === slides.length - 1 ? "#3C3C3C" : "#FFFFFF"} width={24} height={24}>
          <path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path>
        </svg>
      </button>
    </div>
  );
};

export default Slider;
